import * as React from "react";
import { IAuthor } from "~/types/author";
import classNames from "classnames";
import ResponsiveImage from "../responsive-image/responsive-image";

export interface IAuthorImageProps extends Pick<IAuthor, "imageUrl"> {
    className?: string;
}

const AuthorImage = ({ imageUrl, className }: IAuthorImageProps) => {
    const baseClass = "author-image";
    const dummyImageUrl = "/dist/styles/assets/gfx/author/fallback-author-foto.jpg";

    return (
        <div className={classNames(baseClass, className)}>
            <ResponsiveImage
                srcUrl={imageUrl || dummyImageUrl}
                defaultSize={300}
                srcSetSizes={[300]}
                sizes="300px"
            />
        </div>
    );
};

export default AuthorImage;
